// Bangunkan AI (Space) saat login berhasil — keputusan Andra 29 Okt 2026, #1057
// (pilihan C): backend Space boleh tidur, tetapi DIBANGUNKAN OTOMATIS saat login
// klien berhasil. Bukan keep-alive 24 jam.
//
// Alur: setelah login sukses, panggil bangunkanAI() tanpa ditunggu. Ia memanggil
// endpoint ringan (/api/hf-health) lalu mengulang tiap beberapa detik sampai siap
// ATAU batas waktu tercapai. Indikator kecil menampilkan "AI sedang disiapkan".
//
// Modul sengaja TANPA impor berat supaya bisa diuji dengan node (lihat
// tests/hfWake.test.mjs). Jalur ping diambil dari /api/hf-health, sama dengan
// pingHFSpace di lib/aiScanner.js.

let status = 'idle';          // 'idle' | 'warming' | 'ready' | 'timeout'
const pelanggan = new Set();
let timer = null;
let aktif = false;

export const statusAiWake = () => status;

export function subscribeAiWake(fn) {
  pelanggan.add(fn);
  fn(status);
  return () => pelanggan.delete(fn);
}

function setStatus(s) {
  status = s;
  for (const fn of pelanggan) {
    try { fn(s); } catch { /* pelanggan rusak jangan jatuhkan yang lain */ }
  }
}

async function pingDefault(ms) {
  try {
    const res = await fetch('/api/hf-health', { signal: AbortSignal.timeout(ms) });
    return res.ok;
  } catch {
    return false;
  }
}

// Idempoten: panggilan kedua saat sudah berjalan tidak menumpuk timer.
export function bangunkanAI({ ping, maxMs = 300000, setiapMs = 5000, timeoutPingMs = 10000 } = {}) {
  if (aktif) return;
  aktif = true;
  setStatus('warming');
  const p = ping || pingDefault;
  const mulai = Date.now();
  const tick = async () => {
    const ok = await p(timeoutPingMs);
    if (ok) { aktif = false; timer = null; setStatus('ready'); return; }
    if (Date.now() - mulai >= maxMs) { aktif = false; timer = null; setStatus('timeout'); return; }
    timer = setTimeout(tick, setiapMs);
  };
  tick();
}

export function resetAiWake() {
  clearTimeout(timer);
  timer = null;
  aktif = false;
  setStatus('idle');
}
